import { render } from "./ClearUpToolSinglePage.vue?vue&type=template&id=bcb4b784"
import script from "./ClearUpToolSinglePage.vue?vue&type=script&lang=js"
export * from "./ClearUpToolSinglePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__